import React, {Fragment} from "react";
import {BASE_PATH} from "../../../../../wpconfig";
import {NavLink} from "react-router-dom";

const JBasicMeta = (parent) => {
	const record = parent.record;

	if((record.journal_titles && record.journal_titles.length <= 0)
		&&(record.jcr_category && record.jcr_category.length <= 0)
		&&(record.scopus_category && record.scopus_category.length <= 0)
		&&(record.kci_category && record.kci_category.length <= 0)
	)
		return ''

	const a = record.journal_titles && record.journal_titles.length > 0;
	const b = (record.journal_titles && record.journal_titles.length > 0) ||
		((record.jcr_category && record.jcr_category.length <= 0)
		||(record.scopus_category && record.scopus_category.length <= 0)
		||(record.kci_category && record.kci_category.length <= 0))
	const c = (record.journal_titles && record.journal_titles.length > 0) ||
		((record.jcr_category && record.jcr_category.length <= 0)
			||(record.scopus_category && record.scopus_category.length <= 0)
			||(record.kci_category && record.kci_category.length <= 0)) ||
		(record.topic)

	return (
		<div className="mt-2 pt-4 pb-4 border-top border-bottom border-lightgray journal-detail-basicmeta">
			<div>
				{a &&
					<>
						<h3 className="detail-title mb-2">Other Information</h3>
						{record.journal_titles.map((item, num) => {
							return (<div key={num} className="font-size-14 color-lightblack"><span className="mr-2 color-lightblue">{item.type}</span>{item.title}</div>)
						})}
					</>
				}
			</div>

			<div className={'category-wrap ' + (a ? "mt-4" : '')}>
				{(record.jcr_category && record.jcr_category.length >= 0)
				||(record.scopus_category && record.scopus_category.length >= 0)
				||(record.kci_category && record.kci_category.length >= 0) ?
				<h3 className="detail-title mb-3">Categories</h3> : '' }
				<div className="font-size-14 color-lightblack mt-1">
					{(record.jcr_category && record.jcr_category.length) ? <strong className="color-lightpurple mr-2">WoS</strong> : ''}
					{record.jcr_category && record.jcr_category.map((item, index) => {
						return (
							<NavLink key={index} to={BASE_PATH + "journals/?jcr_category[]=" + item.category_name}
							         className="item-subject badge bg-gray text-dark-i mr-1">{item.category_name}</NavLink>
						)
					})}
				</div>

				<div className="font-size-14 color-lightblack mt-1">
					{(record.scopus_category && record.scopus_category.length) ? <strong className="color-lightorange mr-2">Scopus</strong> : ''}
					{record.scopus_category && record.scopus_category.map((item, index) => {
						return (
							<NavLink key={index} to={BASE_PATH + "journals/?scopus_category[]=" + item.category_name}
							         className="item-subject badge bg-gray text-dark-i mr-1">{item.category_name}</NavLink>
						)
					})}
				</div>

				<div className="font-size-14 color-lightblack mt-1">
					{(record.kci_category && record.kci_category.length) ? <strong className="color-lightgreen mr-2">KCI</strong> : ''}
					{record.kci_category && record.kci_category.map((item, index) => {
						return (
							<NavLink key={index} to={BASE_PATH + "journals/?kci_category[]=" + item.category_name}
							         className="item-subject badge bg-gray text-dark-i mr-1">{item.category_name}</NavLink>
						)
					})}
				</div>

				<div className="example-code mt-3" style={{border : '1px solid #e5e5e5'}}>
					<div className="dot-text-list">
						※ 중요 :  저널 인용지표, 등재, 카테고리 랭킹 정보 등은 JCR, WoS, Scopus, KCI, Master Journal List의 업데이트 시점에 따라
							차이가 발생될 수 있으니 오차가 발견 되면 도서관으로 문의 바람<br/>
						- JCR 지표 기준일 : 2025년 10월 15일<br/>
						- Scopus 지표 기준일 : 2025년 5월 5일<br/>
						- KCI 지표 기준일 : 2025년 8월 8일<br/>
						- 지표 설명 참고 : <a href="https://lib.pusan.ac.kr/guide/10180" target="_blank">&lt;연구성과 분석과 평가지표&gt;</a>연구정보가이드<br/>
					</div>
				</div>
			</div>

			{record.topic &&
			<div className={b ? "mt-4" : ''}>
				<h3 className="detail-title mb-2">Topic</h3>
				<div className="font-size-14 color-lightblack">{record.topic}</div>
			</div>
			}

			{record.summary &&
			<div className={c ? "mt-4" : ''}>
				<h3 className="detail-title mb-2">Summary</h3>
				<div className="font-size-14 color-lightblack">{record.summary}</div>
			</div>
			}

		</div>
	);
};

export default JBasicMeta;
